import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from './login/login.component';
import { AngularFireAuthGuard, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { AuthGuard } from './login/auth.guard';
import { PermissionType } from './admin/roles/roles.model';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToIndex = () => redirectLoggedInTo(['panel']);

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'users',
        loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.USER_FULL,
            PermissionType.USER_READ,
            PermissionType.USER_WRITE,
            PermissionType.USER_DELETE,
            PermissionType.USER_UPDATE,
          ],
        },
      },
      {
        path: 'lots',
        loadChildren: () => import('./lots/lots.module').then((m) => m.LotsModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.LOT_FULL,
            PermissionType.LOT_READ,
            PermissionType.LOT_WRITE,
            PermissionType.LOT_DELETE,
            PermissionType.LOT_UPDATE,
          ],
        },
      },
      {
        path: 'panel',
        loadChildren: () => import('./panel/panel.module').then((m) => m.PanelModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.AUCTION_FULL,
            PermissionType.AUCTION_READ,
            PermissionType.AUCTION_WRITE,
            PermissionType.AUCTION_PANEL,
            PermissionType.NOTIFICATIONS_WRITE,
            PermissionType.BID_CUT,
          ],
        },
      },
      {
        path: 'hammer',
        loadChildren: () => import('./hammer/hammer.module').then((m) => m.HammerModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.HAMMER_FULL,
            PermissionType.HAMMER_READ,
            PermissionType.BID_CUT,
          ],
        },
      },
      {
        path: 'config',
        loadChildren: () => import('./config/config.module').then((m) => m.ConfigModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.CONFIG_FULL,
            PermissionType.CONFIG_READ,
            PermissionType.CONFIG_WRITE,
            PermissionType.CONFIG_UPDATE,
          ],
        },
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.REPORTS_FULL,
            PermissionType.REPORTS_READ,
          ],
        },
      },
      {
        path: 'marketing',
        loadChildren: () => import('./marketing/marketing.module').then((m) => m.MarketingModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [
            PermissionType.MARKETING_FULL,
            PermissionType.MARKETING_READ,
            PermissionType.MARKETING_WRITE,
            PermissionType.MARKETING_DELETE,
            PermissionType.MARKETING_UPDATE,
          ],
        },
      },
      {
        path: 'components',
        loadChildren: () => import('./material-component/material.module').then((m) => m.MaterialComponentsModule),
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToIndex },
  },
];
